<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de mensagens padrão</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="Mensagem.mpdId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="Mensagem.mpdNome"
                                        label="Nome" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="Mensagem.mpdAtivo" label="Ativo" :items="StatusAtivo"
                                        item-title="nome" item-value="mpdAtivo" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="12">
                                       <ckeditor :editor="editor" @ready="onReady" v-model="Mensagem.mpdTexto" :config="$ckconfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-file-input v-model="selectedFile" label="Imagem" variant="underlined"
                                        prepend-icon="mdi-image" accept="image/*"></v-file-input>
                                </v-col>
                                <v-col cols="12" md="3" v-if="Mensagem.mpdUrlImagem !== '' && Mensagem.mpdUrlImagem !== null">
                                    <img :src="$imgURL + Mensagem.mpdUrlImagem" style="width: 100px" />
                                    <v-btn icon density="compact" color="red" class="delete-icon" variant="text">
                                        <v-icon @click="DeleteImagem()" style="font-size:22px;">mdi-alpha-x-circle</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="Mensagem.mpdId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="Mensagens" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-mpdAtivo="item">
                            <span>{{ item.mpdAtivo ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
    name: 'CadastroMensagensPadraoView',
    components: {
        EasyDataTable,
    },
    data: () => ({
        editor: DecoupledEditor,
        Mensagem: {
            mpdId: 0,
            mpdNome: '',
            mpdTexto: '',
            mpdAtivo: '',
            mpdUrlImagem: '',
        },
        Mensagens: [],
        StatusAtivo: [{ nome: "Sim", mpdAtivo: true }, { nome: "Não", mpdAtivo: false }],
        headers: [
            { text: "Id", value: "mpdId", sortable: true, },
            { text: "Nome", value: "mpdNome", sortable: true, },
            { text: "Ativo", value: "mpdAtivo", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        selectedFile: null,
    }),
    methods: {
       onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        Limpar() {
            this.Mensagem.mpdId = 0;
            this.Mensagem.mpdNome = '';
            this.Mensagem.mpdTexto = '';
            this.Mensagem.mpdAtivo = '';
            this.Mensagem.mpdUrlImagem = '';
            this.selectedFile = null;
            this.Get();
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Process/UploadImg/upload`, formData);
            return uploadResult;
        },
        async Add() {
            if (this.Mensagem.mpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Mensagem.mpdTexto == ''){
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else {
                if (this.selectedFile != '' && this.selectedFile != null) {
                    console.log(this.selectedFile[0].size)
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        this.Mensagem.mpdUrlImagem = uploadSuccess.data.nameFile;
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.post(`/Process/CadMensagensPadrao/Add`, this.Mensagem)
                        .then(response => {
                            if (response.data > 0) {
                                this.$mensagemAvisoSucesso("Registro Incluído.")
                                this.Get();
                                this.Limpar();
                            }
                        });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
                }
                else {
                    this.Mensagem.mpdUrlImagem = "";
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.post(`/Process/CadMensagensPadrao/Add`, this.Mensagem)
                        .then(response => {
                            if (response.data > 0) {
                                this.$mensagemAvisoSucesso("Registro Incluído.")
                                this.Get();
                                this.Limpar();
                            }
                        });
                }
            }
        },
        async Put() {
            if (this.Mensagem.mpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Mensagem.mpdTexto == ''){
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else {
                if (this.selectedFile != '' && this.selectedFile != null) {
                    console.log(this.selectedFile[0].size)
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        this.Mensagem.mpdUrlImagem = uploadSuccess.data.nameFile;
                        if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                        }
                        axios.put(`/Process/CadMensagensPadrao/Update`, this.Mensagem)
                        .then(response => {
                            if (response.status == 200) {
                                this.$mensagemAvisoSucesso("Registro Alterado.")
                                this.Get();
                                this.Limpar();
                            }
                        });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
                }
                else{
                    if (this.Mensagem.mpdUrlImagem != "") {
                        this.Mensagem.mpdUrlImagem = "0";
                    }
                    if (this.Mensagem.mpdAtivo === "" || this.Mensagem.mpdAtivo === null){
                            this.Mensagem.mpdAtivo = true;
                    }
                    axios.put(`/Process/CadMensagensPadrao/Update`, this.Mensagem)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
                }              
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.Mensagem = item;
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.mpdId;
                axios.delete(`/Process/CadMensagensPadrao/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        DeleteImagem(){
            this.Mensagem.mpdUrlImagem = "";
            /*this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        axios.post(`/Process/UploadImg/delete/${value}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Imagem Excluida.")
                                    
                                }
                            });
                    }
                });*/
        },
        Get() {
            axios.get(`/Process/CadMensagensPadrao/GetAll`)
                .then(response => {
                    this.Mensagens = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
